import React, {  useState } from "react";
import Main from "../Main";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { registerRemitterByNum, registerRemitterVerifryOtp } from "../../api/remitterApi";
import { useNotify } from "../../context/NotifyContext";
import { useFingerprintCapture } from "../../hooks/useFingerprintCapture";
import { getLocation } from "../../components/Navigator/Navigator";
import { useSelector } from "react-redux";
import AadhaarModal from "./AadhaarModal";
import FingerprintModal from "../../hooks/FingerprintModal";
const BeneficiaryForm = () => {
  const {mobile} = useParams()
  const {notify} = useNotify()
  const navigate = useNavigate()
    const { userInfo, location: savedLocation } = useSelector((s) => s.auth);
  const [searchParams, setSearchParams] = useSearchParams();
  const {
  fingerLoading,
  step,
    captureFingerprint,

  } = useFingerprintCapture();
const [loading,setLoading] = useState(false)
const [loadingAgain,setLoadingAgain] = useState(false)
const [initialPhone,setInitialPhone] = useState(mobile)
  const [otp, setOtp] = useState("");
  const [openAadhaarModal, setOpenAadhaarModal] = useState(false);
  const [latlong,setLatLong] = useState({})
const [resendLoading,setLoadingOtp] = useState(false)

const handleSubmit = async () => {
  if (!otp.trim()) {
    return notify("Please enter OTP", "error");
  }

  if (!initialPhone)
    return notify("Phone Number is Required", "error");

  if (initialPhone.length !== 10)
    return notify("Phone Number must be 10 digits", "error");

  setLoading(true);

  const payload = {
    mobile: initialPhone,
    otp: otp,
  };

  try {
    const result = await registerRemitterVerifryOtp(payload);

    // console.log("get the result",result)

    if (result?.success) {
      notify("OTP verified successfully", "success");
      navigate(`/add-beneficiary-bank/${result?.data?._id}`);
    } else {
      notify(result?.message || "Invalid OTP", "error");
    }
  } catch (err) {
    notify("Server error", "error");
  } finally {
    setLoading(false);
  }
};



const startEkycFlow = async (aadhaar) => {
  if (!aadhaar || !latlong) {
    return notify("Missing Aadhaar or Location", "error");
  }

  setLoadingOtp(true);

  try {
    // Capture Fingerprint
    const fpPidData = await captureFingerprint("bank2");

    if (!fpPidData) {
      notify("Fingerprint capture failed", "error");
      return;
    }

    const payload = {
      mobile: mobile,
      aadhaar_number: aadhaar,
      pidData: fpPidData,
      latitude: latlong.latitude,
      longitude: latlong.longitude,
    };

    console.log("EKYC Payload:", payload);

    const result = await registerRemitterByNum(payload);

    if (result?.success) {
      notify("OTP sent successfully", "success");
 
    } else {
      notify(result?.message || "KYC failed", "error");
    }

  } catch (err) {
    console.error("EKYC ERROR:", err);
    notify("Biometric KYC failed", "error");
  } finally {
    setLoadingOtp(false);
  }
};

const handleAadhaarSubmit = (aadhaar) => {
  if (!/^\d{12}$/.test(aadhaar)) {
    return notify("Enter valid 12 digit Aadhaar", "error");
  }
 
  setOpenAadhaarModal(false);
  startEkycFlow(aadhaar);
};


const handleResend = async () => {
  if (!mobile || mobile.length !== 10) {
    return notify("Enter valid phone number", "error");
  }

  try {
 

      let location = savedLocation || (await getLocation());
    if (!location) return notify("Location required", "error");

    if (!location?.latitude || !location?.longitude) {
      notify("Location permission required", "error");
      return;
    }

    setLatLong(location);
    setOpenAadhaarModal(true);

  } catch (err) {
    notify("Please allow location", "error");
  }
};



  return (
    <Main showRightPanel={false}>
      <div className="font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Money Transfer" },
            { label: "Verify OTP" },
          ]}
        />
        <h2 className="text-2xl font-bold text-[var(--text-dark)] mb-2 max-sm:text-xl mt-4">
          Verify OTP
        </h2>
        <div className="ds-card p-4 sm:p-6 w-full max-w-xs lg:max-w-sm mt-4">
          <h2 className="text-[15px] sm:text-lg font-semibold text-[var(--text-dark)] mb-4">
            OTP Verification
          </h2>
          <div className="space-y-4">
            <div>
              <label className="ds-label">
                Enter OTP <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="OTP"
                className="ds-input text-sm"
              />
            </div>
          <div className="ds-form-actions">
  <button
    type="button"
    onClick={handleSubmit}
    disabled={loading}
    className="ds-btn ds-btn-primary"
  >
    {loading ? "Submitting..." : "Submit"}
  </button>
  <button
    type="button"
    onClick={handleResend}
    disabled={loadingAgain || resendLoading}
    className="ds-btn ds-btn-secondary"
  >
    {resendLoading ? "Sending..." : "Resend OTP"}
  </button>
</div>
          </div>
        </div>
      </div>
       <FingerprintModal open={fingerLoading} step={step} />

          <AadhaarModal
  open={openAadhaarModal}
  onClose={() => setOpenAadhaarModal(false)}
  onSubmit={handleAadhaarSubmit}
  loading={resendLoading}
/>
    </Main>
  );
};
export default BeneficiaryForm;
